import { Fragment } from 'react'
import Grid from 'shared/components/search/grid'
import Header from '../containers/header'

const Search = ({ search, user, showTV }) => {
    const { user: searchUser } = search
    const isUserSearch = searchUser && searchUser.username
    return (
        <Fragment>
            <Header user={user} searchInfo={search} />
            <Grid showTV={!isUserSearch && showTV} />
        </Fragment>
    )
}

export default Search
